import { css } from 'emotion';
import DropdownIcon from 'inside-out/images/drop-down-white-icon.svg';
import { grey, aqua, mobileMaxWidthBreakpoint, museo500 } from 'inside-out/global-styles';

export const activeStyle = (activeUnderlineColor, activeTextColor) =>
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			opacity: '1 !important',
			color: `${aqua} !important`,
			'&:after': {
				position: 'absolute',
				top: '-46px',
				display: 'block',
				width: '250px',
				content: 'attr(data-link)',
			},
		},
		[`@media (min-width: ${mobileMaxWidthBreakpoint + 1}px)`]: {
			opacity: '1 !important',
			color: `${activeTextColor} !important`,
			'&:after': {
				content: "' '",
				display: 'block',
				position: 'absolute',
				bottom: 0,
				left: 0,
				width: '100%',
				height: '4px',
				background: activeUnderlineColor,
				borderRadius: 1,
			},
		},
	});

export const wrapperStyle = (textColor, mobileActive) =>
	css({
		...museo500,
		position: 'relative',
		/*
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			whiteSpace: 'nowrap',
			overflowX: 'scroll',
		},
		*/
		[`@media (min-width: ${mobileMaxWidthBreakpoint + 1}px)`]: {
			padding: '0 20px',
			whiteSpace: 'nowrap',
			'& ul': {
				margin: 0,
				padding: 0,
				display: 'flex',
				flexWrap: 'wrap',
				listStyle: 'none',

				'& li': {
					marginRight: '12px',
					padding: 0,
					'&:last-child': {
						marginRight: 0,
					},
					'& a': {
						display: 'inline-block',
						color: textColor,
						opacity: '0.7',
						textDecoration: 'none',
						padding: '12px',
						boxSizing: 'border-box',
						position: 'relative',
						// TODO: Refactor to allow customisable hover color
						'&:hover': {
							color: textColor,
						},
					},
				},
			},
		},
		'& > a': {
			display: 'none',
		},

		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			'& > a': {
				display: 'block',
				height: '46px',
				lineHeight: '46px',
				opacity: '0.7',
				background: '#505E64',
				textIndent: '-9999px',
				position: 'relative',
				'&:after': {
					//transition: 'transform 0.125s',
					position: 'absolute',
					top: '50%',
					right: '10px',
					width: '14px',
					height: '9px',
					content: "' '",
					display: 'block',
					transform: mobileActive ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)',
					background: `url(${DropdownIcon}) no-repeat center center`,
				},
			},
			'& > ul': {
				display: 'block',
				position: 'absolute',
				top: '100%',
				left: mobileActive ? '0' : '-100%',
				margin: '0',
				padding: '0',
				width: '100%',
				boxShadow: 'rgba(0,0,0,0.09) 0 6px 12px 0',
				background: '#fff',
				zIndex: '3',
				'& li': {
					margin: '20px',
					'& a': {
						color: grey,
						fontSize: '16px',
						lineHeight: '21px',
						textDecoration: 'none',
						[`&[aria-current=true]:after`]: {
							pointerEvents: 'none',
							height: '46px',
							lineHeight: '46px',
							color: '#fff',

							fontSize: '10px',
							textTransform: 'uppercase',
							textDecoration: 'none',
							paddingLeft: '10px',
							margin: '0',
							left: mobileActive ? '0' : '100%',
						},
					},
				},
			},
		},
	});

// TODO: emotion specificity to remove !important



// WEBPACK FOOTER //
// ./src/components/shared/pageNav/styles.js